export default "/assets/images/e3f799c6dec9af194c86decdf7392405.png";